import React, { useContext, useEffect } from 'react';

import Typography from '@mui/material/Typography';

import { Hero } from './Hero';
import { Features } from './Features';
import { Contact } from './Contact';
import { Nav } from './Nav';
import { FirebaseContext } from '../firebase/FirebaseContext';
import { useNavigate } from 'react-router-dom';
import { About } from './About';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useContext(FirebaseContext);

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user]);

  return (
    <Nav>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <section id="home">
          <Hero />
        </section>
        <section id="features">
          <Features />
        </section>
        <section id="about">
          <About />
        </section>{' '}
        <section id="contact">
          <Contact />
        </section>
        <footer
          style={{ margin: 50, display: 'flex', justifyContent: 'center' }}
        >
          <Typography>@2022 All right reserved. Rezylist.</Typography>
        </footer>
      </div>
    </Nav>
  );
};
